import { render, staticRenderFns } from "./refundsList.vue?vue&type=template&id=b00a0ac8&scoped=true&"
import script from "./refundsList.vue?vue&type=script&lang=js&"
export * from "./refundsList.vue?vue&type=script&lang=js&"
import style0 from "./refundsList.vue?vue&type=style&index=0&id=b00a0ac8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b00a0ac8",
  null
  
)

export default component.exports